import React from 'react';
import { motion } from 'framer-motion';
import PropertyFilters from '../property/PropertyFilters';

const SearchSection = () => {
  const [filters, setFilters] = React.useState({
    contractType: 'vendita',
    zone: '',
    propertyType: '',
    priceRange: '',
    totalRooms: ''
  });

  const handleFilterChange = (newFilters: any) => {
    setFilters(prev => ({ ...prev, ...newFilters }));
  };

  const handleClearFilters = () => {
    setFilters({
      contractType: 'vendita',
      zone: '',
      propertyType: '',
      priceRange: '',
      totalRooms: ''
    });
  };

  return (
    <section className="bg-gray-50 py-8">
      <div className="container mx-auto px-4 -mt-20 relative z-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <PropertyFilters 
            onFilterChange={handleFilterChange}
            activeFilters={filters}
            onClearFilters={handleClearFilters}
            isHomepage={true}
          />
        </motion.div>
      </div>
    </section>
  );
};

export default SearchSection;